function TabularDataTableCellValidator()
{}

TabularDataTableCellValidator.prototype.init = function()
{
    return this;
};

TabularDataTableCellValidator.prototype.isEmptyOrValid = function( cell )
{
    return this.isEmpty( cell ) || this.isValid( cell );
};

TabularDataTableCellValidator.prototype.isValid = function( cell )
{
    return true;
};

TabularDataTableCellValidator.prototype.isEmpty = function( cell )
{
    return true;
};

export default TabularDataTableCellValidator;



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/tabularDataTable/TabularDataTableCellValidator.js